export class Comment {
    public config_comment_id: number
    public comment: string

    constructor (comment?: string, config_comment_id?: number) {
        this.config_comment_id = config_comment_id
        this.comment = comment
    }
}